'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'AreaRestService',
    function ($modal, AreaRestService) {

        return {
            edit: edit,
            create: create,
            api: AreaRestService
        };

        function create() {
            return $modal.open({
                template: require('../view/area-modal-create.html'),
                controller: 'AreaModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    area: function () {
                        return {};
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/area-modal-create.html'),
                controller: 'AreaModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    area: function () {
                        return item;
                    }
                }
            });
        }

    }];